import { Mail } from 'lucide-react';
import { Tooltip } from '@/components/ui';
import { useFeedback } from './store';

/**
 * The quiet way in to Send feedback: a small, faint button in the corner of every app screen, fully visible on hover or
 * focus. On phones it sits above the bottom tab bar. The fullscreen timer covers it, as it covers everything.
 */
export function FeedbackButton() {
  const setOpen = useFeedback((s) => s.setOpen);
  return (
    <Tooltip label="Send feedback">
      <button type="button" aria-label="Send feedback" onClick={() => setOpen(true)}
        className="fixed z-20 right-4 bottom-[calc(76px+env(safe-area-inset-bottom))] md:bottom-4 size-8 grid place-items-center rounded-full border border-chip-border bg-card text-ink-2 cursor-pointer opacity-40 transition-opacity hover:opacity-100 focus-visible:opacity-100">
        <Mail size={14} />
      </button>
    </Tooltip>
  );
}
